import styled from 'styled-components';

export const Spinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${props => (props.flow === 'block' ? '50vh' : 0)};
  width: ${props => (props.flow === 'block' ? '100%' : 'auto')};
  margin: ${props => (props.margin ? props.margin + 'px' : '')};

  .ant-spin-nested-loading {
    width: 100%;
  }
`;
